<template>
  <div
    ref="title-wrapper"
    class="bg-indigo-100 rounded-md shadow-dark p-2 mx-6 xxl:mx-8 -mb-3 relative text-center text-xs font-semibold text-indigo-400 uppercase tracking-wider leading-normal border-2 z-50"
  >{{ title }}</div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "FeatureTitle",
  props: ["title", "isSelected"],
  computed: {
    titleWrapperRef() {
      return this.$refs["title-wrapper"];
    },
  },
  methods: {
    animateBorder() {
      const borderColor = this.isSelected ? "#7f9cf5" : "#ebf4ff";
      gsap.to(this.titleWrapperRef, { borderColor });
    },
  },
  mounted() {
    this.animateBorder();
  },
  watch: {
    isSelected() {
      this.animateBorder();
    },
  },
};
</script>

<style scoped>
</style>
